import styled, { css, DefaultTheme } from 'styled-components';

type TextProps = {
  color: keyof DefaultTheme['colors'];
};

type DescriptionProps = {
  variant: 'primary' | 'secondary';
};

export const Container = styled.div`
  ${({ theme }) => css`
    padding: 8px 16px;
    background: ${theme.colors.globalWhite100};
    border: 1px solid ${theme.colors.neutralSilver20};
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
    border-radius: 8px;
  `}
`;

export const Text = styled.p<TextProps>`
  ${({ theme, color }) => css`
    color: ${theme.colors[color]};
    font-size: 1.4rem;
    line-height: 2.2rem;
    font-weight: 500;
  `}
`;

const textModifiers = {
  primary: (theme: DefaultTheme) => css`
    color: ${theme.colors.neutralSilver70};
  `,
  secondary: (theme: DefaultTheme) => css`
    color: ${theme.colors.neutralSilver50};
  `,
};

export const Description = styled.div<DescriptionProps>`
  ${({ theme, variant }) => css`
    font-size: 1.4rem;
    line-height: 2.2rem;
    font-weight: 500;

    ${textModifiers[variant](theme)}
  `}
`;
